import React from 'react'
import Layout from '../../component/Admin/AdminLayout'
import AdminHeader from './component/AdminHeader'

const Support = () => {
  return (
    <Layout>
        <AdminHeader title='Customer Support' redirect='/admin-dashboard'/>
    </Layout>
  )
}

export default Support
